import styled from 'styled-components'

import { Colors, mediaQueries } from '@fourthwall/components'

export const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: 0.14px;
  text-align: left;
`

export const CloseButton = styled.button.attrs({ type: 'button' })`
  background: ${Colors.GS200};
  border-radius: 100%;
  padding: 8px;
  color: ${Colors.GS600};

  &:hover {
    background: ${Colors.GS300};
    color: ${Colors.GS800};
  }
`

export const Container = styled.div<{ $visible: boolean }>`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: ${Colors.GS0};
  border-radius: 2px 2px 0 0;
  overflow: hidden;
  z-index: 1;
  transform: translateY(${({ $visible }) => ($visible ? '0' : '100%')});
  opacity: ${({ $visible }) => ($visible ? '1' : '0')};
  transition: all 0.3s;
  cursor: pointer;

  ${mediaQueries.tablet} {
    bottom: 0;
    left: 24px;
    width: 264px;
  }

  &:hover {
    ${Title} {
      color: ${Colors.B500};
    }
  }

  &:has(${CloseButton}:hover) {
    ${Title} {
      color: initial;
    }
  }
`

export const Content = styled.div`
  border-left: 1px solid ${Colors.GS400};
  border-right: 1px solid ${Colors.GS400};
  padding: 8px 16px;
  display: flex;
  gap: 16px;
  align-items: center;

  ${mediaQueries.tablet} {
    padding: 10px 16px 12px;
  }
`

export const TextualContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const Label = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 130%;
  letter-spacing: 0.24px;
  color: ${Colors.GS600};
`
